<style type="text/css">

    /* .container{
        max-width: 700px;
    } */

    .calc {
        max-width: 465px;
        display: block;
        float: left;
    }

    .labelinput {
        width: 100%;
        display: block;
        float: left;
    }

    .calc label {
        width: 350px;
        display: block;
        float: left;
        margin-bottom: 10px;
    }

    .calc input.small {
        width: 60px;
        float: left;
        text-align: right;
    }

    .calc input {
        border: 1px solid silver;
    }

    .in {
        background-color: #ccffcc;
    }

    .out {
        background-color: #ffffcc;
        font-weight: bold;
    }

    .calc span.tag {
        float: left;
    }

    .calc span.inline {
        background-color: #ffffcc;
        padding-left: 8px;
        padding-right: 8px;
    }

    img.illustration {
        margin-top: 15px;
        margin-bottom: 15px;
    }


    /***/

    #myCanvas {
        width: 700px;
        height: 300px;
        columns: 1;
        margin: 0 auto;
    }

    .main-container {
        width: 700px;
        margin: 0 auto;
        display: flex;
        flex-flow: wrap;
        justify-content: center;
    }

        .main-container input {
            width: 80px;
            margin: 0px 10px;
            /* height: 32px; */
            text-align: right;
            font-size: 12pt;
            padding: 5px;
            border: 1px solid gray;
        }

            .main-container input[type=checkbox] {
                width: auto;
            }

            .main-container input::-webkit-outer-spin-button,
            .main-container input::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }

            .main-container input[type=number] {
                -moz-appearance: textfield;
            }

        .main-container label {
            font-family: Verdana, Geneva, Tahoma, sans-serif;
            font-size: 12px;
            margin-right: 5px;
        }

    .ratio-right-input {
        width: 100px !important;
        margin: 0px 10px;
        /* height: 40px; */
        margin-bottom: 10px;
        text-align: left !important;
        font-size: 12pt;
        padding: 8px;
    }

    .ratio-left-input {
        width: 100px !important;
        margin: 0px 10px;
        /* height: 40px; */
        margin-bottom: 10px;
        text-align: right !important;
        font-size: 12pt;
        padding: 8px;
    }

    .select-container {
        margin: 0px 8px;
        padding: 5px;
        width: 150px;
        /* height: 32px; */
    }

    .unit-label {
        font-size: 10pt;
        font-weight: 400;
    }

    .item-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        margin: 10px;
    }

    .f-value-section {
        height: 40px;
        justify-content: center;
    }

    .n-value-section {
        height: 40px;
        justify-content: center;
        padding-right: 31px;
    }

    .l-value-section {
        height: 40px;
        justify-content: flex-start;
    }

    #fixedCheckbox {
        position: relative;
    }

    .value-setting {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-flow: wrap;
    }

    .value-section {
        width: 70%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: wrap;
    }

    .value-section-l {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: wrap;
    }

    .value-container {
        width: 90%;
        margin: 20px auto;
    }

    .button-section {
        width: 90%;
        margin-top: 10px;
    }

        .button-section button {
            display: block;
            width: 80px;
            height: 30px;
            margin-left: 70%;
        }

    .hidden-content {
        width: 0%;
    }

    .validation_red_border {
        border-color: red !important;
    }

    @media screen and (min-width: 320px) {
        #myCanvas {
            width: 100vw;
            height: 50vw;
        }

        .main-container {
            width: 100vw;
        }

        .value-section {
            width: 100%;
        }

        .value-section-l {
            width: 100%
        }

        #f1,
        #f2,
        #f3,
        #f1_ratio1,
        #f2_ratio1,
        #f3_ratio1 {
            margin-left: 32px;
        }

        #f1_ratio2,
        #f2_ratio2,
        #f3_ratio2 {
            margin-left: 2px;
        }

        .f-value-section {
            height: 90px;
            justify-content: flex-start;
            display: flex;
            flex-flow: wrap;
        }

        .n-value-section {
            height: 100px;
            justify-content: flex-start;
            display: flex;
            flex-flow: wrap;
            padding-right: 0px;
        }

        .l-value-section {
            justify-content: flex-start;
        }

        .main-container input {
            width: 60%;
            margin: 8px 5px;
            /* height: 40px; */
        }

        .select-container {
            width: 60%;
            margin: 8px 5px;
            /* height: 40px; */
        }

        .button-section button {
            width: 70%;
            height: 40px;
            margin: 0;
        }

        .button-section {
            margin-left: 5%;
        }

        .hidden-content {
            width: calc(35vw - 70px);
        }

        #fixedCheckbox {
            position: relative;
            margin-left: 0px;
        }
    }

    @media screen and (min-width: 769px) {
        #myCanvas {
            width: 700px;
            height: 300px;
        }

        .main-container {
            width: 768px;
        }

        .value-section {
            width: 100%;
        }

        .value-section-l {
            width: 100%
        }

        .f-value-section {
            justify-content: flex-start;
            height: 40px;
        }

        .n-value-section {
            justify-content: flex-start;
        }

        .l-value-section {
            justify-content: flex-start;
        }

        .main-container input {
            width: 100px;
            margin: 5px 5px;
            /* height: 40px; */
        }

        .select-container {
            width: 150px;
            margin: 5px 5px;
            /* height: 40px; */
        }

        .button-section button {
            width: 100px;
            height: 40px;
            margin-left: 60%;
        }

        .hidden-content {
            width: 0%;
        }

        #fixedCheckbox {
            position: relative;
            margin-left: 35px;
        }
    }

    @media screen and (min-width: 991px) {
        #myCanvas {
            width: 700px;
            height: 300px;
        }

        .main-container {
            width: 700px;
        }

        .hidden-content {
            width: 0%;
        }

        .value-section {
            width: 70%;
        }

        .value-section-l {
            width: 30%
        }

        .f-value-section {
            height: 40px;
        }

        .n-value-section {
            height: 40px;
        }

        #fixedCheckbox {
            position: relative;
            margin-left: 35px;
        }
    }
</style>

<template>

    <div class="container">

    <div class="calc">
        <div class="info">
            <!--<div class="labelinput">
                <label for="t1">
                    1. Ange ytskiktets tjocklek T1 inklusive lim eller fästmassa
                    <br />
                    <i>(För klinker anges t ex 12 mm och för plastmatta t ex 2 mm.)</i>
                </label>
                <span class="tag">T1=</span>
                <input type="number" v-model.number="t1" class="in small" />
            </div>-->
            <div class="labelinput">
                <label for="l1">1. Ange avstånd L1 i mm från tröskel till duschplats</label>
                <span class="tag">L1=</span>
                <input type="number" v-model.number="l1" class="in small" v-on:change="calculate" />
            </div>
            <div class="labelinput">
                <label for="f1">
                    2. Ange önskat fall F1 i mm/m från tröskel till duschplats
                    <br />
                    <i>
                        F1 motsvarar fall
                        <span class="inline" id="f1-f">1 : {{ Math.round(1000 / f1) }}</span>(beräknat från värdet på F1)
                    </i>
                </label>
                <span class="tag">F1=</span>
                <input type="number" v-model.number="f1" class="in small" v-on:change="calculate" />
            </div>
            <div class="labelinput">
                <label for="l2">
                    3. Ange avstånd L2 i mm från duschzonens början till
                    golvbrunn
                </label>
                <span class="tag">L2=</span>
                <input type="number" v-model.number="l2" class="in small" v-on:change="calculate" />
            </div>
            <div class="labelinput">
                <label for="f2">
                    4. Ange önskat fall F2 i mm/m i duschzonen
                    <br />
                    <i>
                        F2 motsvarar fall
                        <span class="inline" id="f2-f">1 : {{ Math.round(1000 / f2) }}</span>(beräknat från värdet på F2)
                    </i>
                </label>
                <span class="tag">F2=</span>
                <input type="number" v-model.number="f2" class="in small" v-on:change="calculate" />
            </div>
            <div class="labelinput">
                <label for="l3">
                    5. Ange avstånd L3 i mm
                </label>
                <span class="tag">L3=</span>
                <input type="number" v-model.number="l3" class="in small"  v-on:change="calculate"/>
            </div>
            <div class="labelinput">
                <label for="f3">
                    6. Ange önskat fall F3 i mm/m
                    <br />
                    <i>
                        F3 motsvarar fall
                        <span class="inline" id="f3-f">1 : {{ Math.round(1000 / f3) }}</span>(beräknat från värdet på F3)
                    </i>
                </label>
                <span class="tag">F3=</span>
                <input type="number" v-model.number="f3" class="in small"  v-on:change="calculate"/>
            </div>
            <div class="labelinput">
                <label for="n1">7. Beräknad nivå N1 som brunnens övre kant skall placeras</label>
                <span class="tag">N1=</span>
                <input type="text"
                       v-model.number="n1"
                       class="out small"
                       readonly="readonly" />
            </div>
            
            <button v-on:click="calculate">Visa/uppdatera mått</button>
            <button v-on:click="draw_mock_up">Visa beteckningar</button>
        </div>
        <div style="width: 100%; display: flex; justify-content: center; flex-flow: column;">
            <canvas id="myCanvas" width="700" height="300">
            </canvas>
            <!--<div class="main-container">                
                <div class="value-container">
                    <div class="value-setting">
                        <div class="value-section-l">
                            <div class="item-container l-value-section">
                                L1 : <input type="number" id="l1" placeholder="">
                                <label class="unit-label" id="l1_label">mm</label>
                            </div>
                            <div class="item-container l-value-section">
                                L2 : <input type="number" id="l2" placeholder="">
                                <label class="unit-label" id="l2_label ">mm</label>
                            </div>
                            <div class="item-container l-value-section">
                                L3 : <input type="number" id="l3" placeholder="">
                                <label class="unit-label" id="l3_label">mm</label>
                            </div>
                        </div>
                        <div class="value-section">
                            <div class="item-container f-value-section">
                                F1 :
                                <select class="select-container" id="f1_opt" onchange="f1_opt_changed(this)">
                                    <option value="3">Gradient slope</option>
                                    <option value="1">Gradient number</option>
                                    <option selected value="2">Gradient ratio</option>
                                    <option value="4">mm/m</option>
                                </select>
                                <input type="number" id="f1" placeholder="" style="display: none;">
                                <div>
                                    <input class="ratio-left-input" type="number" id="f1_ratio1" style="display:inline;" placeholder="">
                                    <label class="unit-label" id="f1_label_ratio" style="display:inline;">:</label>
                                    <input class="ratio-right-input" type="number" id="f1_ratio2" style="display:inline;" placeholder="">
                                </div>
                                <label class="unit-label" id="f1_label"></label>
                            </div>
                            <div class="item-container f-value-section">
                                F2 :
                                <select class="select-container" id="f2_opt" onchange="f2_opt_changed(this)">
                                    <option value="3">Gradient slope</option>
                                    <option value="1">Gradient number</option>
                                    <option selected value="2">Gradient ratio</option>
                                    <option value="4">mm/m</option>
                                </select>
                                <input type="number" id="f2" placeholder="" style="display: none;">
                                <div>
                                    <input class="ratio-left-input" type="number" id="f2_ratio1" style="display:inline;" placeholder="">
                                    <label class="unit-label" id="f2_label_ratio" style="display:inline;">:</label>
                                    <input class="ratio-right-input" type="number" id="f2_ratio2" style="display:inline;" placeholder="">
                                </div>
                                <label class="unit-label" id="f2_label"></label>
                            </div>
                            <div class="item-container f-value-section">
                                F3 :
                                <select class="select-container" id="f3_opt" onchange="f3_opt_changed(this)">
                                    <option value="3">Gradient slope</option>
                                    <option value="1">Gradient number</option>
                                    <option selected value="2">Gradient ratio</option>
                                    <option value="4">mm/m</option>
                                </select>
                                <input type="number" id="f3" placeholder="" style="display: none;">
                                <div>
                                    <input class="ratio-left-input" type="number" id="f3_ratio1" style="display:inline;" placeholder="">
                                    <label class="unit-label" id="f3_label_ratio" style="display:inline;">:</label>
                                    <input class="ratio-right-input" type="number" id="f3_ratio2" style="display:inline;" placeholder="">
                                </div>
                                <label class="unit-label" id="f3_label"></label>
                            </div>
                        </div>

                    </div>
                    <div class="button-section">
                        <button onclick="javascript: getResult();"> Calculate </button>
                    </div>
                </div>
            </div>-->
        </div>

    </div>

    </div>


</template>

<script>
    import GBRGVKServices from "../../services/GBRGVKServices";

    var services = new GBRGVKServices();
    services.log("init");

    export default {
        data: function () {
            return {
                t1: 12,
                l1: 2800,
                f1: 8,
                l2: 700,
                f2: 12,
                k1: 1 / 125,
                k2: 1 / 83,
                f3: 8,
                k3: 1 / 125,
                l3: 500
            };
        },
        methods: {
            calculate: function () {
                draw(this.f1, this.k1, this.l1, this.f2, this.k2, this.l2, this.f3, this.k3, this.l3);
            },
            draw_mock_up: function () {
                draw_mock_up();
            }
        },
        computed: {
            n1: function () {


                return Math.round(this.l1 * this.f1 / 1000 + this.l2 * this.f2 / 1000) * -1;

                //return Math.round(this.t1 + this.l1 * this.f1 / 1000 + this.l2 * this.f2 / 1000) * -1;
            },
        },
        mounted: function () {
              this.$nextTick(function () {
            draw_mock_up(true);
          })
        }
    };

    function draw(f1, k1, l1, f2, k2, l2, f3, k3, l3) {

        var x0 = 10,
            y0 = 200;

        var h0 = 180,
            l0 = 700;

        var door_width = 150,
            door_height = 20;


        var r1_x = 1;
        var r1_y = k1;

        var r2_x = 1;
        var r2_y = k2;

        var r3_x = 1;
        var r3_y = k3;

        var f1_opt_value = "4";
        var f2_opt_value = "4";
        var f3_opt_value = "4";

        var rate = 700.00 / (door_width + l1 + l2 + l3);
        var rate_h = 0.4;
        door_width *= rate, door_height *= rate;
        var x1 = x0 + door_width,
            y1 = y0 - h0 * rate_h;
        var x2 = x1 + l1 * rate;
        var z2 = k1 * l1;
        var y2 = y1 + z2 * rate_h;
        var x3 = x2 + l2 * rate;
        var z3 = k2 * l2;
        var y3 = y2 + z3 * rate_h;
        var x4 = x3 + l3 * rate;
        var z4 = k3 * l3;
        var y4 = y3 - z4 * rate_h;

        var c = document.getElementById("myCanvas");
        if (c == null) {
            c = document.getElementsByTagName("gvk-fallberakning")[0].shadowRoot.getElementById("myCanvas");
        }
        var ctx = c.getContext("2d");

        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, c.width, c.height);

        ctx.scale(0.8,0.8);

        ctx.beginPath();
        ctx.lineWidth = 1.5;

        // tröskel
        ctx.rect(x0, y1 - door_height, door_width, door_height);
        ctx.strokeStyle = "#000000";

        ctx.moveTo(x0, y0);
        ctx.lineTo(x0, y1);
        ctx.lineTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.lineTo(x3, y3);
        ctx.lineTo(x4, y4);
        ctx.lineTo(x4, y0);
        ctx.lineTo(x0, y0);
        ctx.stroke();

        //Draw x1, x2, x3 Horizontal Indicator
        ctx.beginPath();
        ctx.lineWidth = 0.5;
        ctx.moveTo(x1, y1);
        ctx.lineTo(x1, y1 - 40);

        ctx.moveTo(x2, y2);
        ctx.lineTo(x2, y2 - 40);

        ctx.moveTo(x3, y3);
        ctx.lineTo(x3, y3 - 40);

        ctx.moveTo(x4, y4);
        ctx.lineTo(x4, y4 - 40);
        ctx.stroke();

        //Bottom L1, L2, L3
        var hBottomRed = 60;
        ctx.beginPath();
        ctx.strokeStyle = "#a80f02";
        ctx.moveTo(x1 - 5, y0 + hBottomRed); //Bottom Red Line
        ctx.lineTo(x4 + 5, y0 + hBottomRed);

        ctx.moveTo(x1, y0 + hBottomRed + 10); //First Vertical Node
        ctx.lineTo(x1, y0 + hBottomRed - 10);
        ctx.moveTo(x1 - 4, y0 + hBottomRed + 6); //First Skew Node
        ctx.lineTo(x1 + 4, y0 + hBottomRed - 6);

        ctx.moveTo(x2, y0 + hBottomRed + 10); //Second Vertical Node
        ctx.lineTo(x2, y0 + hBottomRed - 10);
        ctx.moveTo(x2 - 4, y0 + hBottomRed + 6); //Second Skew Node
        ctx.lineTo(x2 + 4, y0 + hBottomRed - 6);

        ctx.moveTo(x3, y0 + hBottomRed + 10); //Third Vertical Node
        ctx.lineTo(x3, y0 + hBottomRed - 10);
        ctx.moveTo(x3 - 4, y0 + hBottomRed + 6); //Third Skew Node
        ctx.lineTo(x3 + 4, y0 + hBottomRed - 6);

        ctx.moveTo(x4, y0 + hBottomRed + 10); //Forth Vertical Node
        ctx.lineTo(x4, y0 + hBottomRed - 10);
        ctx.moveTo(x4 - 4, y0 + hBottomRed + 6); //Forth Skew Node
        ctx.lineTo(x4 + 4, y0 + hBottomRed - 6);

        ctx.stroke();

        ctx.font = "20px Arial";
        ctx.textAlign = "center";

        //L1,L2,L3 Text Value

        ctx.beginPath();
        ctx.fillStyle = "#a80f02";
        ctx.fillText(`${l1}`, (x1 + x2) / 2, y0 + hBottomRed - 10);

        ctx.beginPath();
        ctx.fillText(`${l2}`, (x2 + x3) / 2, y0 + hBottomRed - 10);

        ctx.beginPath();
        ctx.fillText(`${l3}`, (x3 + x4) / 2, y0 + hBottomRed - 10);

        //F1, F2, F3 Text Value
        ctx.font = "16px Arial";
        ctx.beginPath();
        ctx.fillStyle = "#e4ad42";

        switch (f1_opt_value) {
            case "1":
                ctx.fillText(`${f1}°`, (x1 + x2) / 2, (y1 + y2) / 2 - 20);
                break;
            case "2":
                ctx.fillText(`${r1_x}:${r1_y}`, (x1 + x2) / 2, (y1 + y2) / 2 - 20);
                break;
            case "3":
                ctx.fillText(`${f1}%`, (x1 + x2) / 2, (y1 + y2) / 2 - 20);
                break;
            case "4":
                ctx.fillText(`${f1}mm/m`, (x1 + x2) / 2, (y1 + y2) / 2 - 20);
                break;
            default:
                break;
        }

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";
        switch (f2_opt_value) {
            case "1":
                ctx.fillText(`${f2}°`, (x2 + x3) / 2, (y2 + y3) / 2 - 20);
                break;
            case "2":
                ctx.fillText(`${r2_x}:${r2_y}`, (x2 + x3) / 2, (y2 + y3) / 2 - 20);
                break;
            case "3":
                ctx.fillText(`${f2}%`, (x2 + x3) / 2, (y2 + y3) / 2 - 20);
                break;
            case "4":
                ctx.fillText(`${f2}mm/m`, (x2 + x3) / 2, (y2 + y3) / 2 - 20);
                break;
            default:
                break;
        }

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";

        switch (f3_opt_value) {
            case "1":
                ctx.fillText(`${f3}°`, (x3 + x4) / 2, (y3 + y4) / 2 - 20);
                break;
            case "2":
                ctx.fillText(`${r3_x}:${r3_y}`, (x3 + x4) / 2, (y3 + y4) / 2 - 20);
                break;
            case "3":
                ctx.fillText(`${f3}%`, (x3 + x4) / 2, (y3 + y4) / 2 - 20);
                break;
            case "4":
                ctx.fillText(`${f3}mm/m`, (x3 + x4) / 2, (y3 + y4) / 2 - 20);
                break;
            default:
                break;
        }


        //F1, F2, F3 Vector
        ctx.font = "20px Arial";
        var stx = (x1 + x2) / 2 - 15;
        var sty = (y1 + y2) / 2 - 12;
        var endx = (x1 + x2) / 2 + 15;
        var endy = sty + 30 * (y2 - y1) / (x2 - x1);
        if (sty < endy) {
            canvas_arrow("#e4ad42", ctx, stx, sty, endx, endy);
        } else {
            canvas_arrow("#e4ad42", ctx, endx, endy, stx, sty);
        }

        stx = (x2 + x3) / 2 - 15;
        sty = (y2 + y3) / 2 - 12;
        endx = (x2 + x3) / 2 + 15;
        endy = sty + 30 * (y3 - y2) / (x3 - x2);
        if (sty < endy) {
            canvas_arrow("#fd837a", ctx, stx, sty, endx, endy);
        } else {
            canvas_arrow("#fd837a", ctx, endx, endy, stx, sty);
        }

        stx = (x3 + x4) / 2 - 15;
        sty = (y3 + y4) / 2 - 12;
        endx = (x3 + x4) / 2 + 15;
        endy = sty + 30 * (y4 - y3) / (x4 - x3);
        if (sty < endy) {
            canvas_arrow("#fd837a", ctx, stx, sty, endx, endy);
        } else {
            canvas_arrow("#fd837a", ctx, endx, endy, stx, sty);
        }

        //Result Height

        ctx.beginPath();
        ctx.fillStyle = "#a80f02";
        ctx.ellipse(x1, y1, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();

        ctx.fillText(`(${Math.round(z2 + z3)})`, x1, y2 - 60);

        ctx.beginPath();
        ctx.fillStyle = "#e4ad42";
        ctx.ellipse(x2, y2, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();
        ctx.fillText(`(${Math.round(z3)})`, x2, y2 - 60);

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";
        ctx.ellipse(x3, y3, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();
        ctx.fillText(`(${Math.round(0)})`, x3, y3 - 60);

        ctx.beginPath();
        ctx.fillStyle = "#eac160";
        ctx.ellipse(x4, y4, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();
        ctx.fillText(`(${Math.round(z4)})`, x4, y4 - 60);

        //Height Text And Line
        ctx.beginPath();
        ctx.strokeStyle = "#fd837a";
        ctx.moveTo(x1, y1); //Bottom Red Line
        ctx.lineTo(x1 + l0 + 30, y1);
        ctx.moveTo(x3, y3);
        ctx.lineTo(x1 + l0 + 30, y3);

        ctx.moveTo(x1 + l0 + 20, y1);
        ctx.lineTo(x1 + l0 + 20, y3);

        ctx.moveTo(x1 + l0 + 20 + 3, y1 - 3);
        ctx.lineTo(x1 + l0 + 20 - 3, y1 + 3);

        ctx.moveTo(x1 + l0 + 20 + 3, y3 - 3);
        ctx.lineTo(x1 + l0 + 20 - 3, y3 + 3);

        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";

        var calcN1 = Math.round(l1 * f1 / 1000 + l2 * f2 / 1000) * -1;

        //ctx.fillText(`${Math.round(Math.max(z2 + z3, z4, z3))} mm`, x1 + l0 + 70, y1);
        ctx.fillText(`${calcN1} mm`, x1 + l0 + 70, y1);

    }

    function canvas_arrow(color, context, fromx, fromy, tox, toy) {
        context.beginPath();
        context.lineWidth = 0.5;
        context.strokeStyle = color;
        var headlen = 8; // length of head in pixels
        var dx = tox - fromx;
        var dy = toy - fromy;
        var angle = Math.atan2(dy, dx);
        context.moveTo(fromx, fromy);
        context.lineTo(tox, toy);
        context.stroke();

        context.beginPath();
        context.fillStyle = color;
        context.moveTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
        context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
        context.fill();
        context.stroke();
    }

    function draw_mock_up() {

        var x0 = 10,
            y0 = 200;

        var h0 = 180,
            l0 = 700;

        var door_width = 150,
            door_height = 20;

        var k1 = 2 / 100;
        var l1 = 1298 * 1;

        var k2 = 5.66 / 100;
        var l2 = 602 * 1;

        var k3 = 15.66 / 100;
        var l3 = 302 * 1;

        var rate = 700.00 / (door_width + l1 + l2 + l3);
        var rate_h = 0.4;
        door_width *= rate, door_height *= rate;
        var x1 = x0 + door_width,
            y1 = y0 - h0 * rate_h;
        var x2 = x1 + l1 * rate;
        var z2 = k1 * l1;
        var y2 = y1 + z2 * rate_h;
        var x3 = x2 + l2 * rate;
        var z3 = k2 * l2;
        var y3 = y2 + z3 * rate_h;
        var x4 = x3 + l3 * rate;
        var z4 = k3 * l3;
        var y4 = y3 - z4 * rate_h;

        var c = document.getElementById("myCanvas");
        if (c == null) {
            c = document.getElementsByTagName("gvk-fallberakning")[0].shadowRoot.getElementById("myCanvas");
        }
        var ctx = c.getContext("2d");            
        
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, c.width, c.height);
        
        ctx.scale(0.8,0.8);

        ctx.beginPath();
        ctx.lineWidth = 1.5;
        ctx.rect(x0, y1 - door_height, door_width, door_height);
        ctx.strokeStyle = "#000000";
        ctx.moveTo(x0, y0);
        ctx.lineTo(x0, y1);
        ctx.lineTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.lineTo(x3, y3);
        ctx.lineTo(x4, y4);
        ctx.lineTo(x4, y0);
        ctx.lineTo(x0, y0);
        ctx.stroke();

        //Draw x1, x2, x3 Horizontal Indicator
        ctx.beginPath();
        ctx.lineWidth = 0.5;
        ctx.moveTo(x1, y1);
        ctx.lineTo(x1, y1 - 40);

        ctx.moveTo(x2, y2);
        ctx.lineTo(x2, y2 - 40);

        ctx.moveTo(x3, y3);
        ctx.lineTo(x3, y3 - 40);

        ctx.moveTo(x4, y4);
        ctx.lineTo(x4, y4 - 40);
        ctx.stroke();

        //Bottom L1, L2, L3
        var hBottomRed = 60;
        ctx.beginPath();
        ctx.strokeStyle = "#a80f02";
        ctx.moveTo(x1 - 5, y0 + hBottomRed); //Bottom Red Line
        ctx.lineTo(x4 + 5, y0 + hBottomRed);

        ctx.moveTo(x1, y0 + hBottomRed + 10); //First Vertical Node
        ctx.lineTo(x1, y0 + hBottomRed - 10);
        ctx.moveTo(x1 - 4, y0 + hBottomRed + 6); //First Skew Node
        ctx.lineTo(x1 + 4, y0 + hBottomRed - 6);

        ctx.moveTo(x2, y0 + hBottomRed + 10); //Second Vertical Node
        ctx.lineTo(x2, y0 + hBottomRed - 10);
        ctx.moveTo(x2 - 4, y0 + hBottomRed + 6); //Second Skew Node
        ctx.lineTo(x2 + 4, y0 + hBottomRed - 6);

        ctx.moveTo(x3, y0 + hBottomRed + 10); //Third Vertical Node
        ctx.lineTo(x3, y0 + hBottomRed - 10);
        ctx.moveTo(x3 - 4, y0 + hBottomRed + 6); //Third Skew Node
        ctx.lineTo(x3 + 4, y0 + hBottomRed - 6);

        ctx.moveTo(x4, y0 + hBottomRed + 10); //Forth Vertical Node
        ctx.lineTo(x4, y0 + hBottomRed - 10);
        ctx.moveTo(x4 - 4, y0 + hBottomRed + 6); //Forth Skew Node
        ctx.lineTo(x4 + 4, y0 + hBottomRed - 6);

        ctx.stroke();

        ctx.font = "20px Arial";
        ctx.textAlign = "center";

        //L1,L2,L3 Text Value

        ctx.beginPath();
        ctx.fillStyle = "#a80f02";
        ctx.fillText(`L1`, (x1 + x2) / 2, y0 + hBottomRed - 10);

        ctx.beginPath();
        ctx.fillText(`L2`, (x2 + x3) / 2, y0 + hBottomRed - 10);

        ctx.beginPath();
        ctx.fillText(`L3`, (x3 + x4) / 2, y0 + hBottomRed - 10);

        //F1, F2, F3 Text Value
        ctx.beginPath();
        ctx.fillStyle = "#e4ad42";
        ctx.fillText(`F1`, (x1 + x2) / 2, (y1 + y2) / 2 - 20);

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";
        ctx.fillText(`F2`, (x2 + x3) / 2, (y2 + y3) / 2 - 20);

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";
        ctx.fillText(`F3`, (x3 + x4) / 2, (y3 + y4) / 2 - 20);

        //F1, F2, F3 Vector

        var stx = (x1 + x2) / 2 - 15;
        var sty = (y1 + y2) / 2 - 12;
        var endx = (x1 + x2) / 2 + 15;
        var endy = sty + 30 * (y2 - y1) / (x2 - x1);
        if (sty < endy) {
            canvas_arrow("#e4ad42", ctx, stx, sty, endx, endy);
        } else {
            canvas_arrow("#e4ad42", ctx, endx, endy, stx, sty);
        }

        stx = (x2 + x3) / 2 - 15;
        sty = (y2 + y3) / 2 - 12;
        endx = (x2 + x3) / 2 + 15;
        endy = sty + 30 * (y3 - y2) / (x3 - x2);
        if (sty < endy) {
            canvas_arrow("#fd837a", ctx, stx, sty, endx, endy);
        } else {
            canvas_arrow("#fd837a", ctx, endx, endy, stx, sty);
        }

        stx = (x3 + x4) / 2 - 15;
        sty = (y3 + y4) / 2 - 12;
        endx = (x3 + x4) / 2 + 15;
        endy = sty + 30 * (y4 - y3) / (x4 - x3);
        if (sty < endy) {
            canvas_arrow("#fd837a", ctx, stx, sty, endx, endy);
        } else {
            canvas_arrow("#fd837a", ctx, endx, endy, stx, sty);
        }

        //Result Height

        ctx.beginPath();
        ctx.fillStyle = "#a80f02";
        ctx.ellipse(x1, y1, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();

        ctx.fillText(`z1`, x1, y2 - 60);

        ctx.beginPath();
        ctx.fillStyle = "#e4ad42";
        ctx.ellipse(x2, y2, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();
        ctx.fillText(`z2`, x2, y2 - 60);

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";
        ctx.ellipse(x3, y3, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();
        ctx.fillText(`z3`, x3, y3 - 60);

        ctx.beginPath();
        ctx.fillStyle = "#eac160";
        ctx.ellipse(x4, y4, 4, 4, 0, 0, Math.PI * 2, false);
        ctx.fill();
        ctx.fillText(`z4`, x4, y4 - 60);

        //Height Text And Line
        ctx.beginPath();
        ctx.strokeStyle = "#fd837a";
        ctx.moveTo(x1, y1); //Bottom Red Line
        
        ctx.lineTo(x1 + l0 - 20, y1);
        
        ctx.moveTo(x3, y3);
        ctx.lineTo(x1 + l0 - 20, y3);

        ctx.moveTo(x1 + l0 + -30, y1);
        ctx.lineTo(x1 + l0 + -30, y3);

        ctx.moveTo(x1 + l0 - 30 + 3, y1 - 3);
        ctx.lineTo(x1 + l0 - 30 - 3, y1 + 3);

        ctx.moveTo(x1 + l0 - 30 + 3, y3 - 3);
        ctx.lineTo(x1 + l0 - 30 - 3, y3 + 3);

        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle = "#fd837a";

        ctx.fillText(`N1 = z1 - z3`, x1 + l0 + 40, (y1 + y3) / 2 + 5);
    }



</script>